$(document).on('click', 'a.pagination__link, button.pagination__button', (e) => {
  e.preventDefault()
  $('html, body').animate({
    scrollTop: $('.section-news-preview').offset().top
  }, 400);
  return false;
})
